import { IUserCard, IUserCardData, IUserCardAction } from 'models/user/usercard';
import { IFollowCardItem } from 'models/verticalwidgetcards/followcard';
import { IFollowingItem, IPage, IFollowerDto, ISearchDto, IEntityDto, IComment } from 'models/common';
import { IUserPreferences } from 'models/user/userpreferences';
import { IStore } from 'redux/IStore';
import { ILike } from 'models/user/like';
import { IRecentActivity } from 'models/user/recentactivity';
import { SearchUsage } from 'models/enums/searchusage';
import { browserHistory } from 'react-router';
import { RootCategory } from 'models';
import * as c from 'models/constants';

/** Styles Module */
import { getUserOutfits } from 'redux/modules/outfit/outfits';

/** Wishlist Module */
import { getWishlist } from 'modules/user/wishlist';

/** WardrobeItems Module */
import {
	getWardrobeItemsSearchResults,
	setWardrobeItemSelectedCategory,
} from 'redux/modules/search/wardrobeitemsearchresults';
import { accessTokenIsPresent } from 'containers/AccessControl/helpers';
import { getProfileTabUrl } from 'helpers/common';

/** Action Types */
export const REQUEST_START: string = 'usercard/REQUEST_START';
export const GET_SUCCESS: string = 'usercard/GET_SUCCESS';
export const REQUEST_FAILURE: string = 'usercard/REQUEST_FAILURE';
export const REQUEST_FAILURE_REVIEW: string = 'usercard/REQUEST_FAILURE_REVIEW';
export const CHANGE_SELECTED_TAB: string = 'usercard/CHANGE_SELECTED_TAB';
export const FOLLOW_USER_REQUEST: string = 'usercard/FOLLOW_USER_REQUEST';
export const FOLLOW_USER_SUCCESS: string = 'usercard/FOLLOW_USER_SUCCESS';
export const UNFOLLOW_USER_SUCCESS: string = 'usercard/UNFOLLOW_USER_SUCCESS';
export const FOLLOW_USER_FAILURE: string = 'usercard/FOLLOW_USER_FAILURE';
export const SET_IS_FOLLOWED: string = 'usercard/SET_IS_FOLLOWED';
export const GET_USER_FOLLOWING_SUCCESS: string = 'usercard/GET_USER_FOLLOWING_SUCCESS';
export const GET_USER_FOLLOWERS_SUCCESS: string = 'usercard/GET_USER_FOLLOWERS_SUCCESS';
export const SET_USER_FOLLOWING_PAGE: string = 'usercard/SET_USER_FOLLOWING_PAGE';
export const SET_USER_FOLLOWERS_PAGE: string = 'usercard/SET_USER_FOLLOWERS_PAGE';
export const SET_SHOW_FOLLOWING: string = 'usercard/SHOW_FOLLOWING';
export const SET_SHOW_FOLLOWERS: string = 'usercard/SHOW_FOLLOWERS';
export const CLOSE_WIDGET_AND_RESET_USER_FOLLOWING: string = 'usercard/CLOSE_WIDGET_AND_RESET_USER_FOLLOWING';
export const CLOSE_WIDGET_AND_RESET_USER_FOLLOWERS: string = 'usercard/CLOSE_WIDGET_AND_RESET_USER_FOLLOWERS';
export const SET_IS_MY_PROFILE: string = 'usercard/SET_IS_MY_PROFILE';
export const RESET_DATA: string = 'usercard/RESET_DATA';
export const RESET_USER_FOLLOWERS_DATA: string = 'usercard/RESET_USER_FOLLOWERS_DATA';
export const RESET_USER_FOLLOWING_DATA: string = 'usercard/RESET_USER_FOLLOWING_DATA';
export const GET_RECENT_ACTIVITIES_SUCCESS: string = 'usercard/GET_RECENT_ACTIVITIES_SUCCESS';
export const SET_RECENT_ACTIVITIES_PAGE: string = 'usercard/SET_RECENT_ACTIVITIES_PAGE';
export const RESET_RECENT_ACTIVITIES_DATA: string = 'usercard/RESET_RECENT_ACTIVITIES_DATA';
export const GET_LIKES_SUCCESS: string = 'usercard/GET_LIKES_SUCCESS';
export const SET_LIKES_PAGE: string = 'usercard/SET_LIKES_PAGE';
export const RESET_LIKES_DATA: string = 'usercard/RESET_LIKES_DATA';
export const SET_KEYWORD_FILTER: string = 'products/SET_KEYWORD_FILTER';
export const SET_USER_COMMENT: string = 'usercard/SET_USER_COMMENT';

/** Initial State */
const initialState: IUserCardData = {
	isFetching: false,
	usercard: null,
	isFollowed: null,
	followingItems: [],
	followersItems: [],
	followingPage: {
		currentPage: 0,
		itemsPerPage: 10,
	},
	followersPage: {
		currentPage: 0,
		itemsPerPage: 10,
	},
	showFollowing: false,
	showFollowers: false,
	isMyProfile: false,
	selectedTab: c.USERCARD_TAB_WARDROBEITEMS,
	tabsNamespace: c.USERCARD_TABS_NAMESPACE,
	recentActivities: [],
	recentActivitiesPage: {
		currentPage: 0,
		itemsPerPage: 10,
	},
	likes: [],
	likesPage: {
		currentPage: 0,
		itemsPerPage: 10,
	},
	keywordFilter: '',
	reviewBoxError: {
		status: 0,
		statusText: '',
		error: [],
	},
};

/** Reducer */
export function userCardReducer(state = initialState, action: IUserCardAction) {
	switch (action.type) {
		case REQUEST_START:
			return Object.assign({}, state, {
				isFetching: true,
			});

		case GET_SUCCESS:
			return Object.assign({}, state, {
				usercard: action.payload.usercarddata,
				isFetching: false,
			});

		case REQUEST_FAILURE:
			return Object.assign({}, state, {
				message: action.payload.message,
				error: true,
			});
		case REQUEST_FAILURE_REVIEW:
			return Object.assign({}, state, {
				reviewBoxError: action.payload.message,
			});

		case CHANGE_SELECTED_TAB:
			return Object.assign({}, state, {
				selectedTab: action.payload.selectedTab,
			});

		case FOLLOW_USER_REQUEST:
			return Object.assign({}, state, {
				isFollowed: undefined,
			});

		case FOLLOW_USER_SUCCESS:
			return Object.assign({}, state, {
				isFollowed: true,
			});

		case UNFOLLOW_USER_SUCCESS:
			return Object.assign({}, state, {
				isFollowed: false,
			});

		case SET_IS_FOLLOWED:
			return Object.assign({}, state, {
				isFollowed: action.payload.isFollowed,
			});

		case GET_USER_FOLLOWING_SUCCESS:
			return Object.assign({}, state, {
				followingItems: action.payload.followingItems,
			});

		case GET_USER_FOLLOWERS_SUCCESS:
			return Object.assign({}, state, {
				followersItems: action.payload.followersItems,
			});

		case SET_USER_FOLLOWING_PAGE:
			return Object.assign({}, state, {
				followingPage: action.payload.followingPage,
			});

		case SET_USER_FOLLOWERS_PAGE:
			return Object.assign({}, state, {
				followersPage: action.payload.followersPage,
			});

		case SET_SHOW_FOLLOWING:
			return Object.assign({}, state, {
				showFollowing: action.payload.showFollowing,
			});

		case SET_SHOW_FOLLOWERS:
			return Object.assign({}, state, {
				showFollowers: action.payload.showFollowers,
			});

		case CLOSE_WIDGET_AND_RESET_USER_FOLLOWING:
			return Object.assign({}, state, {
				showFollowing: false,
				followingItems: [],
				followingPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			});

		case CLOSE_WIDGET_AND_RESET_USER_FOLLOWERS:
			return Object.assign({}, state, {
				showFollowers: false,
				followersItems: [],
				followersPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			});

		case SET_IS_MY_PROFILE:
			return Object.assign({}, state, {
				isMyProfile: action.payload.isMyProfile,
			});

		case RESET_DATA:
			return Object.assign({}, state, initialState);

		case RESET_USER_FOLLOWERS_DATA:
			return Object.assign({}, state, {
				followersItems: [],
				followersPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			});

		case RESET_USER_FOLLOWING_DATA:
			return Object.assign({}, state, {
				followingItems: [],
				followingPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			});

		case GET_RECENT_ACTIVITIES_SUCCESS:
			return Object.assign({}, state, {
				recentActivities: action.payload.recentActivities,
			});

		case SET_RECENT_ACTIVITIES_PAGE:
			return Object.assign({}, state, {
				recentActivitiesPage: action.payload.recentActivitiesPage,
			});

		case RESET_RECENT_ACTIVITIES_DATA:
			return Object.assign({}, state, {
				recentActivities: [],
				recentActivitiesPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			});

		case GET_LIKES_SUCCESS:
			return Object.assign({}, state, {
				likes: action.payload.likes,
			});

		case SET_LIKES_PAGE:
			return Object.assign({}, state, {
				likesPage: action.payload.likesPage,
			});

		case RESET_LIKES_DATA:
			return Object.assign({}, state, {
				likes: [],
				likesPage: {
					currentPage: 0,
					itemsPerPage: 10,
				},
			});

		case SET_KEYWORD_FILTER:
			return Object.assign({}, state, {
				keywordFilter: action.payload.keywordFilter,
				isFirstLoad: true,
			});

		default:
			return state;
	}
}

/** Action Creator */
export function changeTabAndGetRequiredData(selectedTab: string, userId: string) {
	return (dispatch, getState: () => IStore) => {
		dispatch(changeSelectedTab(selectedTab));

		const userCardState: IUserCardData = getState().usercard;

		switch (selectedTab) {
			case c.USERCARD_TAB_OVERVIEW:
				break;
			case c.USERCARD_TAB_WARDROBEITEMS:
				if (!getState().wardrobeItemSearchResults.selectedCategoryId) {
					dispatch(setWardrobeItemSelectedCategory(RootCategory.Women));
				}
				dispatch(getWardrobeItemsSearchResults(true, false, SearchUsage.WardrobeItemsUserCard));
				break;

			case c.USERCARD_TAB_OUTFITS:
				dispatch(getUserOutfits(userId, true));
				break;

			case c.USERCARD_TAB_WISHLIST:
				dispatch(getWishlist(userCardState.usercard.id, true));
				break;

			case c.USERCARD_TAB_ARTICLES:
				console.error('This should not have happened!');
				break;

			case c.USERCARD_TAB_ACTIVITY:
				dispatch(getRecentActivities(userId, true));
				break;

			case c.USERCARD_TAB_LIKES:
				dispatch(getLikes(userId, true));
				break;

			case c.USERCARD_TAB_FOLLOWERS:
				dispatch(getUserFollowers(userId, true, null));
				break;

			case c.USERCARD_TAB_FOLLOWING:
				dispatch(getUserFollowing(userId, true, null));
				break;

			default:
				break;
		}
	};
}

/** Action Creator */
export function changeSelectedTab(selectedTab: string): IUserCardAction {
	return {
		type: CHANGE_SELECTED_TAB,
		payload: {
			selectedTab,
		},
	};
}

/** Action Creator */
export function getUserCardByCode(code: string) {
	return (dispatch, getState: () => IStore) => {
		const userPreferencesState: IUserPreferences = getState().userPreferences;

		let isMyProfile = false;

		if (userPreferencesState.code !== null && code === userPreferencesState.code) {
			isMyProfile = true;
			code = userPreferencesState.code;
		}

		dispatch(setIsMyProfile(isMyProfile));

		dispatch(requestStart());

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + code + '/GetByCode',
			Object.assign({}, getState().fetchDefault.requestInit),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IUserCard) => {
						setUserCardData(res, userPreferencesState, dispatch, isMyProfile);
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

export function fetchUserCardById(getState: () => IStore, id: string): Promise<IUserCard> {
	return fetch(
		getState().fetchDefault.baseAPI + 'api/user/' + id,
		Object.assign({}, getState().fetchDefault.requestInit),
	).then((res) => {
		if (res.ok) {
			return res.json().then((res: IUserCard) => res);
		} else {
			const status: number = res.status;
			const statusText: string = res.statusText;
			return res
				.json()
				.then((res) => {
					res.status = status;
					res.statusText = statusText;
					throw res;
				})
				.catch(() => {
					const message: any = { status, statusText };
					throw message;
				});
		}
	});
}

/** Action Creator */
export function getUserCard(id: string, target?: string) {
	return (dispatch, getState: () => IStore) => {
		const userPreferencesState: IUserPreferences = getState().userPreferences;

		let isMyProfile = false;

		if (userPreferencesState.id !== null && id === userPreferencesState.id) {
			isMyProfile = true;
			id = userPreferencesState.id;
		}

		dispatch(setIsMyProfile(isMyProfile));

		dispatch(requestStart());

		return fetchUserCardById(getState, id)
			.then((res: IUserCard) => {
				setUserCardData(res, userPreferencesState, dispatch, isMyProfile);

				const url = '/profile/' + res.code + getProfileTabUrl('default');

				if (target && target.length > 0) {
					window.open(url, target);
				} else {
					browserHistory.push(url);
				}
			})
			.catch((m) => {
				dispatch(requestFailure(m));
			});
	};
}

function setUserCardData(res: IUserCard, userPreferences: IUserPreferences, dispatch, isMyProfile: boolean) {
	dispatch(userCardSuccess(res));

	if (userPreferences && userPreferences.id && !isMyProfile) {
		dispatch(getUserCardFollowButtonData());
	} else {
		dispatch(setUserIsFollowed(false));
	}
}

/** Action Creator */
export function getUserCardFollowButtonData() {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		dispatch(requestStart());

		const entityIds: IEntityDto[] = [];
		entityIds.push({ entityId: getState().usercard.usercard.entityId });

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(entityIds),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => dispatch(setUserIsFollowed(res[0].value)));
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getUserFollowing(userId: string, isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetUserFollowingData());
		}

		dispatch(requestStart());

		const userPreferences: IUserPreferences = getState().userPreferences;

		const currentPage: number = getState().usercard.followingPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().usercard.followingPage.itemsPerPage;

		const searchData: ISearchDto = {
			keyword,
			currentPage: newPage,
			itemsPerPage,
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + userId + '/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(searchData),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						const userCardState: IUserCardData = getState().usercard;
						const followingItems: IFollowerDto[] = userCardState.followingItems;
						Array.prototype.push.apply(followingItems, res.items);
						dispatch(getUserFollowingSuccess(followingItems));
						dispatch(setUserFollowingPage(res));

						if (userPreferences.id !== null) {
							const isMyProfile = getState().usercard.isMyProfile;

							if (isMyProfile) {
								const followingItems = userCardState.followingItems;
								followingItems.map((item) => {
									item.following = true;
								});
								dispatch(getUserFollowingSuccess(followingItems));
							} else {
								dispatch(getFollowingOrFollowersButtonsData(res.items, true, false));
							}
						} else {
							dispatch(updateFollowingOrFollowersButtonsData(null, true, false));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getUserFollowers(userId: string, isFirstLoad: boolean, keyword: string) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetUserFollowersData());
		}

		dispatch(requestStart());

		const userPreferences: IUserPreferences = getState().userPreferences;

		const currentPage: number = getState().usercard.followersPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().usercard.followersPage.itemsPerPage;

		const searchData: ISearchDto = {
			keyword,
			currentPage: newPage,
			itemsPerPage,
		};

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + userId + '/Followers',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(searchData),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res: IPage) => {
						const userCardState: IUserCardData = getState().usercard;
						const followersItems: IFollowerDto[] = userCardState.followersItems;
						Array.prototype.push.apply(followersItems, res.items);
						dispatch(getUserFollowersSuccess(followersItems));
						dispatch(setUserFollowersPage(res));

						if (userPreferences.id !== null) {
							dispatch(getFollowingOrFollowersButtonsData(res.items, false, true));
						} else {
							dispatch(updateFollowingOrFollowersButtonsData(null, false, true));
						}
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function followUser(id: string, isUserCardFollowButton: boolean, onSuccess?: () => void) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		if (isUserCardFollowButton) {
			dispatch(followUserStart());
		} else {
			dispatch(updateFollowButtonInFollowingFollowersLists(id, undefined));
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/user/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					const isMyProfile = getState().usercard.isMyProfile;

					if (isMyProfile) {
						// dispatch(updateFollowButtonInFollowingFollowersLists(id, true));
						dispatch(updateFollowingCount());
						// } else {
					}
					if (isUserCardFollowButton) {
						dispatch(followUserSuccess());
						dispatch(updateFollowersCount());
					} else {
						dispatch(updateFollowButtonInFollowingFollowersLists(id, true));
					}
					if (typeof onSuccess === 'function') {
						onSuccess();
					}
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function unfollowItem(
	id: string,
	type: string,
	isUserCardFollowButton: boolean,
	isFollowingTab: boolean = false,
	onSuccess?: () => void,
) {
	return (dispatch, getState: () => IStore) => {
		if (isUserCardFollowButton) {
			dispatch(followUserStart());
		} else {
			dispatch(updateFollowButtonInFollowingFollowersLists(id, undefined));
		}

		return fetch(
			getState().fetchDefault.baseAPI + 'api/' + type + '/' + id + '/follow',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'DELETE',
			}),
		)
			.then((res) => {
				if (res.ok || res.status === 409) {
					const isMyProfile = getState().usercard.isMyProfile;

					if (isMyProfile) {
						// dispatch(updateFollowButtonInFollowingFollowersLists(id, false));
						dispatch(updateFollowingCount(true));
						// } else {
					}
					if (isUserCardFollowButton) {
						dispatch(unfollowUserSuccess());
						dispatch(updateFollowersCount(true));
					} else {
						dispatch(updateFollowButtonInFollowingFollowersLists(id, false));
					}

					if (isFollowingTab) {
						const userCardState = getState().usercard;
						dispatch(getUserFollowing(userCardState.usercard.id, true, userCardState.keywordFilter));
					}
					if (typeof onSuccess === 'function') {
						onSuccess();
					}
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateFollowButtonInFollowingFollowersLists(itemId: string, type: boolean | undefined) {
	return (dispatch, getState: () => IStore) => {
		const userCardState: IUserCardData = getState().usercard;

		const followingItems: IFollowerDto[] = [...userCardState.followingItems];
		const followersItems: IFollowerDto[] = [...userCardState.followersItems];

		let followingItemToUpdate = followingItems.find((x) => JSON.parse(x.entityId).id === itemId);
		let followerItemToUpdate = followersItems.find((x) => JSON.parse(x.entityId).id === itemId);

		const followingItemIndex = followingItems.indexOf(followingItemToUpdate);
		const followerItemIndex = followersItems.indexOf(followerItemToUpdate);

		if (followingItemToUpdate !== undefined) {
			followingItemToUpdate = { ...followingItemToUpdate };
			followingItemToUpdate.following = type;
			if (type === true) {
				followingItemToUpdate.followersCount++;
			} else if (type === false) {
				followingItemToUpdate.followersCount--;
			}

			followingItems[followingItemIndex] = followingItemToUpdate;
			dispatch(getUserFollowingSuccess(followingItems));
		}

		if (followerItemToUpdate !== undefined) {
			followerItemToUpdate = { ...followerItemToUpdate };
			followerItemToUpdate.following = type;
			if (type === true) {
				followerItemToUpdate.followersCount++;
			} else if (type === false) {
				followerItemToUpdate.followersCount--;
			}
			followersItems[followerItemIndex] = followerItemToUpdate;
			dispatch(getUserFollowersSuccess(followersItems));
		}
	};
}

/** Action Creator */
export function updateFollowersCount(isUnfollow: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		const userCard: IUserCard = getState().usercard.usercard;
		if (isUnfollow) {
			userCard.followersCount--;
		} else {
			userCard.followersCount++;
		}
		dispatch(userCardSuccess(userCard));
	};
}

/** Action Creator */
export function updateFollowingCount(isUnfollow: boolean = false) {
	return (dispatch, getState: () => IStore) => {
		const userCard: IUserCard = getState().usercard.usercard;
		if (isUnfollow) {
			userCard.followingCount--;
		} else {
			userCard.followingCount++;
		}
		dispatch(userCardSuccess(userCard));
	};
}

/** Action Creator */
export function getFollowingOrFollowersButtonsData(
	items: IFollowCardItem[],
	isFollowing: boolean,
	isFollowers: boolean,
) {
	return (dispatch, getState: () => IStore) => {
		if (!accessTokenIsPresent()) {
			return Promise.resolve(false);
		}
		if (!items.length) {
			return;
		}
		dispatch(requestStart());

		const itemsToGet: IEntityDto[] = items.map((item) => {
			return {
				entityId: item.entityId,
			};
		});

		return fetch(
			getState().fetchDefault.baseAPI + 'api/User/Following',
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(itemsToGet),
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						dispatch(updateFollowingOrFollowersButtonsData(res, isFollowing, isFollowers));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function updateFollowingOrFollowersButtonsData(
	followingItems: IFollowingItem[],
	isFollowing: boolean,
	isFollowers: boolean,
) {
	return (dispatch, getState: () => IStore) => {
		const userCardState: IUserCardData = getState().usercard;

		let itemsToUpdate: IFollowCardItem[] = [];
		if (isFollowing) {
			itemsToUpdate = userCardState.followingItems;
		}
		if (isFollowers) {
			itemsToUpdate = userCardState.followersItems;
		}
		itemsToUpdate = JSON.parse(JSON.stringify(itemsToUpdate)); // clone

		if (followingItems !== null) {
			followingItems.map((followingItem: IFollowingItem) => {
				const item: IFollowCardItem = itemsToUpdate.filter((i) => i.entityId === followingItem.key.entityId)[0];
				if (item) {
					const itemIndex = itemsToUpdate.indexOf(item);
					item.following = followingItem.value;
					itemsToUpdate[itemIndex] = item;
				} else {
					itemsToUpdate[itemsToUpdate.length] = {
						entityId: followingItem.key.entityId,
						following: followingItem.value,
					};
				}
			});
		} else {
			itemsToUpdate.map((item) => {
				item.following = false;
			});
		}

		if (isFollowing) {
			dispatch(getUserFollowingSuccess(itemsToUpdate));
		}
		if (isFollowers) {
			dispatch(getUserFollowersSuccess(itemsToUpdate));
		}
	};
}

/** Action Creator */
export function getRecentActivities(id: string, isFirstLoad: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetRecentActivitiesData());
		}

		dispatch(requestStart());

		const url = 'api/User/' + id + '/RecentActivities';

		const currentPage: number = getState().usercard.recentActivitiesPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().usercard.recentActivitiesPage.itemsPerPage;

		const queryString = '?CurrentPage=' + newPage + '&ItemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + url + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						const items: IRecentActivity[] = getState().usercard.recentActivities;
						const newItems: IRecentActivity[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getRecentActivitiesSuccess(items));
						dispatch(setRecentActivitiesPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function getLikes(id: string, isFirstLoad: boolean) {
	return (dispatch, getState: () => IStore) => {
		if (isFirstLoad) {
			dispatch(resetLikesData());
		}

		dispatch(requestStart());

		const url = 'api/User/' + id + '/Likes';

		const currentPage: number = getState().usercard.likesPage.currentPage;
		const newPage: number = currentPage + 1;
		const itemsPerPage: number = getState().usercard.likesPage.itemsPerPage;

		const queryString = '?CurrentPage=' + newPage + '&ItemsPerPage=' + itemsPerPage;

		return fetch(
			getState().fetchDefault.baseAPI + url + queryString,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'GET',
			}),
		)
			.then((res) => {
				if (res.ok) {
					return res.json().then((res) => {
						const items: ILike[] = getState().usercard.likes;
						const newItems: ILike[] = res.items;
						Array.prototype.push.apply(items, newItems);
						dispatch(getLikesSuccess(items));
						dispatch(setLikesPage(res));
					});
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailure(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailure(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailure(err));
			});
	};
}

/** Action Creator */
export function addUserReview(review: IComment) {
	return (dispatch, getState: () => IStore) => {
		dispatch(requestStart());
		return fetch(
			getState().fetchDefault.baseAPI + `api/User/Comment`,
			Object.assign({}, getState().fetchDefault.requestInit, {
				method: 'POST',
				body: JSON.stringify(review),
			}),
		)
			.then((res) => {
				if (res.ok) {
					// TODO CHECK THIS
					// return res.json().then(() => {
					//   dispatch(notifSend({ message: i18n.t('Notification_Success_ShopReview_Added'), kind: 'success', dismissAfter: 6000 }));
					//   dispatch(reset(c.FORM_NAME_ADD_COMMENT));
					//   dispatch(getShopReviews(comment.parentId, true));
					// });
				} else {
					const status: number = res.status;
					const statusText: string = res.statusText;
					return res
						.json()
						.then((res) => {
							res.status = status;
							res.statusText = statusText;
							dispatch(requestFailureReview(res));
						})
						.catch(() => {
							const message: any = { status, statusText };
							dispatch(requestFailureReview(message));
						});
				}
			})
			.catch((err) => {
				dispatch(requestFailureReview(err));
			});
	};
}

/** Action Creator */
export function requestStart(): IUserCardAction {
	return {
		type: REQUEST_START,
	};
}

/** Action Creator */
export function userCardSuccess(userCard: IUserCard): IUserCardAction {
	return {
		type: GET_SUCCESS,
		payload: {
			usercarddata: userCard,
		},
	};
}

/** Action Creator */
export function requestFailure(message: any): IUserCardAction {
	return {
		type: REQUEST_FAILURE,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function requestFailureReview(message: any): IUserCardAction {
	return {
		type: REQUEST_FAILURE_REVIEW,
		payload: {
			message,
		},
	};
}

/** Action Creator */
export function followUserStart(): IUserCardAction {
	return {
		type: FOLLOW_USER_REQUEST,
	};
}

/** Action Creator */
export function followUserSuccess(): IUserCardAction {
	return {
		type: FOLLOW_USER_SUCCESS,
	};
}

/** Action Creator */
export function unfollowUserSuccess(): IUserCardAction {
	return {
		type: UNFOLLOW_USER_SUCCESS,
	};
}

/** Action Creator */
export function setUserIsFollowed(isFollowed: boolean): IUserCardAction {
	return {
		type: SET_IS_FOLLOWED,
		payload: {
			isFollowed,
		},
	};
}

/** Action Creator */
export function getUserFollowingSuccess(followingItems: IFollowCardItem[]): IUserCardAction {
	return {
		type: GET_USER_FOLLOWING_SUCCESS,
		payload: {
			followingItems,
		},
	};
}

/** Action Creator */
export function getUserFollowersSuccess(followersItems: IFollowCardItem[]): IUserCardAction {
	return {
		type: GET_USER_FOLLOWERS_SUCCESS,
		payload: {
			followersItems,
		},
	};
}

/** Action Creator */
export function setUserFollowingPage(followingPage: IPage): IUserCardAction {
	return {
		type: SET_USER_FOLLOWING_PAGE,
		payload: {
			followingPage,
		},
	};
}

/** Action Creator */
export function setUserFollowersPage(followersPage: IPage): IUserCardAction {
	return {
		type: SET_USER_FOLLOWERS_PAGE,
		payload: {
			followersPage,
		},
	};
}

/** Action Creator */
export function setShowFollowing(show: boolean): IUserCardAction {
	return {
		type: SET_SHOW_FOLLOWING,
		payload: {
			showFollowing: show,
		},
	};
}

/** Action Creator */
export function setShowFollowers(show: boolean): IUserCardAction {
	return {
		type: SET_SHOW_FOLLOWERS,
		payload: {
			showFollowers: show,
		},
	};
}

/** Action Creator */
export function closeWidgetAndResetUserFollowing(): IUserCardAction {
	return {
		type: CLOSE_WIDGET_AND_RESET_USER_FOLLOWING,
	};
}

/** Action Creator */
export function closeWidgetAndResetUserFollowers(): IUserCardAction {
	return {
		type: CLOSE_WIDGET_AND_RESET_USER_FOLLOWERS,
	};
}

/** Action Creator */
export function setIsMyProfile(isMyProfile: boolean): IUserCardAction {
	return {
		type: SET_IS_MY_PROFILE,
		payload: {
			isMyProfile,
		},
	};
}

/** Action Creator */
export function resetData(): IUserCardAction {
	return {
		type: RESET_DATA,
	};
}

/** Action Creator */
export function resetUserFollowersData(): IUserCardAction {
	return {
		type: RESET_USER_FOLLOWERS_DATA,
	};
}

/** Action Creator */
export function resetUserFollowingData(): IUserCardAction {
	return {
		type: RESET_USER_FOLLOWING_DATA,
	};
}

/** Action Creator */
export function getRecentActivitiesSuccess(recentActivities: IRecentActivity[]): IUserCardAction {
	return {
		type: GET_RECENT_ACTIVITIES_SUCCESS,
		payload: {
			recentActivities,
		},
	};
}

/** Action Creator */
export function setRecentActivitiesPage(recentActivitiesPage: IPage): IUserCardAction {
	return {
		type: SET_RECENT_ACTIVITIES_PAGE,
		payload: {
			recentActivitiesPage,
		},
	};
}

/** Action Creator */
export function resetRecentActivitiesData(): IUserCardAction {
	return {
		type: RESET_RECENT_ACTIVITIES_DATA,
	};
}

/** Action Creator */
export function getLikesSuccess(likes: ILike[]): IUserCardAction {
	return {
		type: GET_LIKES_SUCCESS,
		payload: {
			likes,
		},
	};
}

/** Action Creator */
export function setLikesPage(likesPage: IPage): IUserCardAction {
	return {
		type: SET_LIKES_PAGE,
		payload: {
			likesPage,
		},
	};
}

/** Action Creator */
export function resetLikesData(): IUserCardAction {
	return {
		type: RESET_LIKES_DATA,
	};
}

export function setKeywordFilter(keywordFilter: string): IUserCardAction {
	return {
		type: SET_KEYWORD_FILTER,
		payload: {
			keywordFilter,
		},
	};
}
